// theme.ts
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#41bb6a",
            contrastText: "#fff"
        }
    }
});

export default theme;
